module.exports = __webpack_public_path__ + "static/media/DSC_DV.de356d61.png";